import { Component, OnInit, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { User } from 'src/app/models/user.model';
import { AuthService, UserService, EmployeeService } from 'src/app/services';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'app-top-menu-partner',
  templateUrl: './top-menu-partner.component.html',
  styleUrl: './top-menu-partner.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconButton, MatIcon, NgClass, MatButton, MatMenuTrigger, MatMenu, MatMenuItem, RouterLink],
})
export class TopMenuPartnerComponent implements OnInit {
  protected router = inject(Router);
  private auth = inject(AuthService);
  private userService = inject(UserService);

  readonly employee = inject(EmployeeService);

  showHeaderMenu: boolean = false;
  me: User = null as any;
  parentUser: User = null as any;

  readonly has_pending_slack = computed((): boolean => this.employee.hasPendingSlackChatConnections());

  ngOnInit(): void {
    this.me = this.userService.getCurrentUser();
    this._listenUser();
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/auth', 'login']);
  }

  private _listenUser() {
    this.userService.currentUser.subscribe(data => {
      this.me = data;
    });
    this.userService.currentParentUser.subscribe(data => {
      this.parentUser = data;
    });
  }

  protected desimpersonar() {
    this.auth.desimpersonate();
    this.router.navigate(['/employees/direction/users']);
  }
}
